import React from 'react';
import './Analytics.css'; // Optional: if you want to add page-specific styles

const Analytics = () => (
    <div className="cards">
        <div className="card">
            <h3>Total Users</h3>
            <p>1,234</p>
        </div>
        <div className="card">
            <h3>Active Sessions</h3>
            <p>567</p>
        </div>
        <div className="card">
            <h3>New Signups</h3>
            <p>89</p>
        </div>
        <div className="card">
            <h3>Revenue</h3>
            <p>$12,345</p>
        </div>
    </div>
);

export default Analytics;